// Components
const ModalAddAdmin = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-add-admin"*/ '@/app/views/main-view/users/components/modals/modal-add-admin/modal-add-admin.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

// Constants
import { STATUS_CODES, USER_ROLE } from '@/app/constants/constants';
import UserService from "@/app/services/main/user/user-service";

export default {
    name: 'UserAdminComponent',
    components: {
        ModalAddAdmin
    },
    mixins: [
        tableMixins,
        toastMessageMixins
    ],
    data() {
		const statusList = [{name:'ACTIVE', value: 'ACTIVE'}, {name:'INACTIVE', value: 'INACTIVE'}, {name:'PENDING', value: 'PENDING'}];

        return {
            isBreedsAPILoading: false,
            isAPILoading: false,
            // table
            theads: [
                { name: 'Email', sortLabel: 'emailAddress', searchLabel: 'f_emailAddress', isDesc: false, hasSearch: true, style: null},
                { name: 'First Name', sortLabel: 'firstName', isDesc: false, searchLabel: 'f_firstName', hasSearch: true, style: null},
                { name: 'Last Name', sortLabel: 'lastName', isDesc: false, searchLabel: 'f_lastName', hasSearch: true, style: null},
				{ name: 'Status', sortLabel: 'status', isDesc: false, searchLabel: 'f_status', hasSearchableDropdown: true, optionList: statusList, style: 'min-width: 200px'},
                { name: '', sortLabel: ''},
            ],
            // sorting
            sortBy: '',
            desc: true,
            filterAdminStatus: ''
        }
    },
    watch: {
        filterAdminStatus() {
            this.getTableContent(true);
        }
    },
    created() {
        this.getTableContent();
    },
    methods: {
        getTableContent(fromFilter, page= this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
            this.getAdminUsers({ page, limit, sortBy, desc });
        },
        getAdminUsers(queryParams) {
            // default filter
            queryParams['f_role'] = USER_ROLE.USER_ADMIN;

            // search filters
            if (this.columnsFilter) {
                const { f_emailAddress, f_firstName, f_lastName } = this.columnsFilter;

                if (f_emailAddress) {
                    queryParams['f_emailAddress'] = f_emailAddress;
                }

                if (f_firstName) {
                    queryParams['f_firstName'] = f_firstName;
                }

                if (f_lastName) {
                    queryParams['f_lastName'] = f_lastName;
                }
            }

			// search dropdown filters
			if (this.columnsFilter) {
				const {
					f_status
				} = this.columnsFilter;

				if (f_status) {
					queryParams['f_status'] = f_status;
				}
			}

            this.isAPILoading = true;

            UserService.getUserList(queryParams)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: res.data.data,
                            paginationData: res.data.pagination
                        };
                    } else {
                        this.showAPIErrorToast('Unable to get User List', res);
                    }

                    this.isAPILoading = false;
                }).catch(() => {
                    this.showGenericErrorToast();
                    this.isAPILoading = false;
                });
        },
        toggleAdminStatus(event, admin) {
            let flag = event.target.checked;
            const alertTitle = `${flag ? 'Activate' : 'Deactivate'} Admin User`;
            const alertMsg = `Are you sure you want to ${flag ? 'activate' : 'deactivate'} Admin User?`;

            this.$swal({
                title: alertTitle,
                text: alertMsg,
                confirmButtonText: 'Confirm',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                reverseButtons: true,
				showCloseButton: true
            })
                .then(result => {
                    if (result.value) {
                        this.callAdminUserToggleAPI(admin, flag, event);
                    } else {
                        event.target.checked = !flag;
                    }
                });
        },
        callAdminUserToggleAPI(admin, flag, event) {
            const { id: userId, firstName, lastName  } = admin;

            const handleResponse = res => {
                const adminName = `Admin ${firstName} ${lastName}`;

				if (res.status === STATUS_CODES.SUCCESS) {
					this.showCustomSuccessToast(`Successfully ${flag ? 'activated' : 'deactivated'} ${adminName}`);
					event.target.checked = flag;
				} else {
					this.showAPIErrorToast(`Unable to ${flag ? 'reactivate' : 'deactivate'} ${adminName}.`, res);
					event.target.checked = !flag;
				}
			}

			const handleCatch = () => { 
				this.showGenericErrorToast();
				event.target.checked = !flag;
			} 

			const userDetails = {
				status: flag ? 'A' : 'I'
			}

			UserService.updateUserStatus(userId, userDetails)
                .then(handleResponse)
                .catch(handleCatch);
        },
        showAddAdminModal() {
            this.$refs.modalAddAdmin.show();
        },
        handleRefreshTableContent() {
            this.getTableContent();
        },
        resendActivationLink(user) {
			const {firstName, lastName} = user;
			
			this.$swal({
				title: 'Resend Activation Link',
				text: `Are you sure you want to resend activation link to email ${firstName} ${lastName}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
				.then(result => {
					if (result.value) {
						this.callResendActivationLink(user);
					}
				});
		},
		callResendActivationLink(user) {
			const {firstName, lastName, emailAddress} = user;
			const handleResponse = res => {
				if(res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showCustomSuccessToast(`Successfully send reactivation link to ${firstName} ${lastName}`);
				} else {
					this.showAPIErrorToast(`Unable to send reactivation link`, res);
				}
			}

			const handleCatch = () => { 
				this.showGenericErrorToast();
			} 
			
			UserService.resendLink(emailAddress)
				.then(handleResponse)
				.catch(handleCatch);
		}
    }
}